import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SeoData } from "../types/seodata";
import SEO from "./seo";
const PageWrapper: React.FC = () => {
//const PageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
 // const pageSEO = SeoData.find((page) => page.url === pathname);
const pageSEO = SeoData.find((page) => page.url === pathname);
  return (
    <>
      {pageSEO && (
        <>
          <SEO
            canonical={pageSEO.canonical}
            existingTitle={pageSEO.existing_title}
            recommendedTitle={pageSEO.recommended_title}
            metaDescription={pageSEO.meta_description}
            suggestedDesc={pageSEO.suggested_desc}
            suggestedH1={pageSEO.suggested_h1}
             parsedSchema={pageSEO.parsedSchema}
          />
        
        </>
      )}
    
        {/* {children} */}
        <Outlet />
     
    </>
  );
};

export default PageWrapper;